module.exports = __webpack_public_path__ + "static/iphone-noticeboard-677a2a49f180a6a980aab1a00022c6a5.png";